// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GtmUserDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GtmUserDataQuery = { __typename?: 'Query', userManagement?: { __typename?: 'UserManagement', currentProfile?: { __typename?: 'UserManagementProfile', _id?: string, username?: string, email?: string, affiliateID?: string } } };


export const GtmUserDataDocument = /*#__PURE__*/ gql`
    query GtmUserData {
  userManagement {
    currentProfile {
      _id
      username
      email
      affiliateID
    }
  }
}
    `;
export function useGtmUserDataQuery(baseOptions?: Apollo.QueryHookOptions<GtmUserDataQuery, GtmUserDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GtmUserDataQuery, GtmUserDataQueryVariables>(GtmUserDataDocument, options);
      }
export function useGtmUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GtmUserDataQuery, GtmUserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GtmUserDataQuery, GtmUserDataQueryVariables>(GtmUserDataDocument, options);
        }
export function useGtmUserDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GtmUserDataQuery, GtmUserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GtmUserDataQuery, GtmUserDataQueryVariables>(GtmUserDataDocument, options);
        }
export type GtmUserDataQueryHookResult = ReturnType<typeof useGtmUserDataQuery>;
export type GtmUserDataLazyQueryHookResult = ReturnType<typeof useGtmUserDataLazyQuery>;
export type GtmUserDataSuspenseQueryHookResult = ReturnType<typeof useGtmUserDataSuspenseQuery>;
export type GtmUserDataQueryResult = Apollo.QueryResult<GtmUserDataQuery, GtmUserDataQueryVariables>;